<ion-item class="p-l-10 no-pad-left">
    <ion-input #searchInput
      class="m-l-20"
      placeholder="Search"
      clearInput
      [ngModel]="searchText"
      (ngModelChange)="searchChange.emit($event)"
    >
    </ion-input>
  </ion-item>
  <ion-item class="p-l-10" lines="none" *ngIf="isMulti">
    <ion-checkbox
      class="m-t-10 m-b-10"
      [ngModel]="checked"
      [indeterminate]="indeterminate"
      (ngModelChange)="selectAllChange.emit($event)"
      slot="start"
    >
    </ion-checkbox>
    <ion-label>Select All</ion-label>
  </ion-item>
  